import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoButton from './LogoButton';

const Header = () => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const dropdownRef = useRef(null);


    const toggleMenu = () => {
        setMenuOpen((prev) => !prev);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setMenuOpen(false); // Close the menu if clicked outside
        }
    };

    useEffect(() => {
        // Add event listener for clicks
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Cleanup event listener on unmount
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    return (
        <header className="header">
            <div className="logo">
                <LogoButton />
            </div>
            <div className="nav-buttons">
                <button onClick={() => navigate('/about')} className='btn'>About Us</button>
                <button onClick={() => navigate('/features')} className='btn'>Features</button>
                <button onClick={() => navigate('/auth')} className="btn">Sign In</button>
                <button onClick={() => navigate('/auth')} className="btn">Sign Up</button>
                <button onClick={toggleMenu} className="menu-btn" aria-label="Toggle menu">
                    {/* Three-line icon */}
                    <div className="menu-icon">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </button>
            </div>
            {/* Dropdown menu */}
            {menuOpen && (
                <div className="dropdown-menu" ref={dropdownRef}>
                    <button onClick={() => navigate('/future-feature-1')} className="dropdown-item">Future Feature 1</button>
                    <button onClick={() => navigate('/future-feature-2')} className="dropdown-item">Future Feature 2</button>
                    <button onClick={() => navigate('/future-feature-3')} className="dropdown-item">Future Feature 3</button>
                </div>
            )}
        </header>
    );
};

export default Header;
